import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e0a018c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-count-down" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ends" }, "Ends in", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "colon" }, ":", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "colon" }, ":", -1))
const _hoisted_5 = { class: "colon" }
const _hoisted_6 = {
  key: 1,
  class: "not-started"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "starting" }, "Starting in", -1))
const _hoisted_8 = { class: "flash_sale_time" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode()
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, ":", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_count_down = _resolveComponent("van-count-down")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.havebegun)
      ? (_openBlock(), _createBlock(_component_van_count_down, {
          key: 0,
          time: $props.timestamp,
          millisecond: ""
        }, {
          default: _withCtx((timeData) => [
            _hoisted_2,
            _createElementVNode("span", {
              class: "block",
              style: _normalizeStyle({background:$props.backgroundColor})
            }, _toDisplayString(timeData.hours>=10?timeData.hours:('0' + timeData.hours)), 5),
            _hoisted_3,
            _createElementVNode("span", {
              class: "block",
              style: _normalizeStyle({background:$props.backgroundColor})
            }, _toDisplayString(timeData.minutes>=10?timeData.minutes:('0'+timeData.minutes)), 5),
            _hoisted_4,
            _createElementVNode("span", {
              class: "block",
              style: _normalizeStyle({background:$props.backgroundColor})
            }, _toDisplayString(timeData.seconds>=10?timeData.seconds:('0'+timeData.seconds)), 5),
            _withDirectives(_createElementVNode("span", _hoisted_5, ":", 512), [
              [_vShow, $props.openDown]
            ]),
            _withDirectives(_createElementVNode("span", {
              class: "block",
              style: _normalizeStyle({background:$props.backgroundColor})
            }, _toDisplayString(timeData.milliseconds>=10?timeData.milliseconds:('0'+timeData.milliseconds)), 5), [
              [_vShow, $props.openDown]
            ])
          ]),
          _: 1
        }, 8, ["time"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.doesList, (item, index) => {
              return (_openBlock(), _createElementBlock("p", { key: index }, [
                _createElementVNode("span", null, _toDisplayString(item.length === 1 ? '0' + item : item), 1),
                _hoisted_9,
                _hoisted_10
              ]))
            }), 128))
          ])
        ]))
  ]))
}